// ObiHub OS kabuğunun menüsü: Emergent'in 6 modülü (Merkez, Satışlar, Finans, Operasyon, Zekâ, Şirketler),
// içerik olarak mevcut kenar menüsünün gerçek yolları ve yetki kuralları (çalışmayan bağlantı yok, sayfa kaybı yok).
import { hasAnyPermission, permissionSet, withPanelBase } from "@/lib/authz";

const BILLING = ["billing.view", "billing.manage"];
const CATALOG = ["catalog.view", "catalog.manage"];
const INVENTORY = ["inventory.view", "inventory.manage"];
const DASH = ["dashboard.view"];

const GROUPS = [
  { key: "home", label: "Merkez", hint: "İşletmenin günlük durumu", icon: "home", items: [
    { key: "overview", label: "Genel Bakış", icon: "home", to: "/panel" },
  ] },
  { key: "sales", label: "Satışlar", hint: "Sipariş, POS ve faturalama", icon: "sales", items: [
    { key: "pos", label: "Satış Ekranı", icon: "pos", to: "/panel/satis", requiredAny: DASH },
    { key: "sales-invoices", label: "Satış Faturaları", icon: "invoice", to: "/panel/satislar/fatura-olustur", requiredAny: BILLING },
    { key: "outgoing", label: "Giden Faturalar", icon: "outgoing", to: "/panel/satislar/faturalar", requiredAny: BILLING },
    { key: "offers", label: "Teklifler", icon: "list", to: "/panel/satislar/teklifler", requiredAny: BILLING },
  ] },
  { key: "finance", label: "Finans", hint: "Cari, nakit ve belgeler", icon: "finance", items: [
    { key: "finance", label: "Finans Merkezi", icon: "finance", to: "/panel/finans", requiredAny: [...BILLING, "reports.view"] },
    { key: "customers", label: "Cari Hesaplar", icon: "users", to: "/panel/musteriler", requiredAny: ["customers.view", "customers.manage"] },
    { key: "kasa", label: "Kasa & Bankalar", icon: "wallet", to: "/panel/kasa", requiredAny: BILLING },
    { key: "incoming", label: "Gelen Faturalar", icon: "incoming", to: "/panel/giderler/gelen-e-faturalar", requiredAny: BILLING },
    { key: "reports", label: "Gelir & Gider", icon: "scale", to: "/panel/raporlar", requiredAny: ["reports.view"] },
  ] },
  { key: "ops", label: "Operasyon", hint: "Ürün, stok ve senkronizasyon", icon: "ops", items: [
    { key: "products", label: "Ürünler", icon: "product", to: "/panel/urunler", requiredAny: CATALOG },
    { key: "categories", label: "Kategoriler", icon: "category", to: "/panel/kategoriler", requiredAny: CATALOG },
    { key: "warehouses", label: "Stok & Depolar", icon: "warehouse", to: "/panel/stok", requiredAny: INVENTORY },
    { key: "product-stock", label: "Ürün Stok Listesi", icon: "list", to: "/panel/urun-stok", requiredAny: INVENTORY },
    { key: "product-prices", label: "Ürün Fiyat Listesi", icon: "price", to: "/panel/urun-fiyat", requiredAny: INVENTORY },
    { key: "jobs", label: "Entegrasyon İşlemleri", icon: "jobs", to: "/panel/urunler/islemler", requiredAny: CATALOG },
    { key: "hepsijet", label: "HepsiJet", icon: "truck", to: "/panel/operasyon/hepsijet-etiket", requiredAny: INVENTORY },
  ] },
  { key: "intel", label: "Zekâ", hint: "Obi AI önerileri ve riskler", icon: "intel", items: [
    { key: "ai", label: "AI Ürün Zekası", icon: "brain", to: "/panel/ai-intelligence", requiredAny: CATALOG },
  ] },
  { key: "companies", label: "Şirketler", hint: "Firma, kullanıcı ve ayarlar", icon: "companies", items: [
    { key: "my-companies", label: "Firmalarım", icon: "companies", to: "/panel/hesabim/firmalarim", requiredAny: DASH },
    { key: "integrations", label: "Entegrasyonlar", icon: "integrations", to: "/panel/entegrasyonlar", requiredAny: ["integrations.view", "integrations.manage"] },
    { key: "settings", label: "Ayarlar", icon: "settings", to: "/panel/ayarlar", requiredAny: ["settings.view", "settings.manage"] },
    { key: "logs", label: "Loglar", icon: "logs", to: "/panel/loglar", requiredAny: ["logs.view"] },
    { key: "subscription", label: "Abonelik", icon: "card", to: "/panel/hesabim/abonelik", requiredAny: DASH },
    { key: "billing", label: "Faturalandırma", icon: "card", to: "/panel/hesabim/faturalandirma", requiredAny: DASH },
    { key: "apps", label: "Uygulamalar", icon: "apps", to: "/panel/uygulamalar", requiredAny: DASH },
    { key: "invite", label: "Davet Et, Kazan", icon: "gift", to: "/panel/hesabim/davet-et-kazan", requiredAny: DASH },
  ] },
];
const NEW_ACTIONS = [
  { key: "invoice", label: "Satış faturası kes", icon: "invoice", to: "/panel/satislar/fatura-olustur/yeni", requiredAny: BILLING },
  { key: "offer", label: "Teklif hazırla", icon: "list", to: "/panel/satislar/teklifler", requiredAny: BILLING },
  { key: "pos", label: "Satış ekranı", icon: "pos", to: "/panel/satis", requiredAny: DASH },
];
const ORG_MENU = [{ key: "companies", label: "Firmalarım", to: "/panel/hesabim/firmalarim", requiredAny: DASH }];
const FOOTER = [{ key: "support", label: "Destek", icon: "help", to: "/panel/hesabim/destek-taleplerim", requiredAny: DASH }];

const initials = (name) => String(name || "").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toLocaleUpperCase("tr")).join("") || "?";

// Sidebar.js ile aynı çalışma anı koşulları; varsayılanlar Sidebar'ın başlangıç durumuyla aynı.
export function buildFinanceShell(user, pathname, { support = true, hepsiJet = false, accountingProvider = "" } = {}) {
  const granted = permissionSet(user);
  const visible = (it) => {
    if (it.key === "support") return support;
    if (it.key === "hepsijet") return hepsiJet;
    if (it.key === "incoming" && accountingProvider === "bizimhesap") return false;
    return true;
  };
  const allow = (it) => visible(it) && (!it.requiredAny || hasAnyPermission(granted, it.requiredAny));
  const link = ({ requiredAny, ...it }) => ({ ...it, to: withPanelBase(it.to, user, pathname) });
  const groups = GROUPS.map((g) => ({ ...g, items: g.items.filter(allow).map(link) })).filter((g) => g.items.length);
  return {
    org: { name: user?.company_name || user?.tenant_name || "ObiHub", sub: "Ön muhasebe" },
    groups, activeGroup: "finance", activeItem: "incoming",
    home: withPanelBase("/panel", user, pathname),
    railFooter: FOOTER.filter(allow).map(link),
    newActions: NEW_ACTIONS.filter(allow).map(link),
    orgMenu: ORG_MENU.filter(allow).map(link),
    user: { initials: initials(user?.name || user?.full_name || user?.email), name: user?.name || user?.full_name || "", role: "" },
  };
}
